import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const currencies = {
    "es-AR": {
        decimalSeparator: ",",
        localeCode: "es-AR",
        symbol: "$",
    },
    "pt-BR": {
        decimalSeparator: ",",
        localeCode: "pt-BR",
        symbol: "R$",
    },
    "es-MX": {
        decimalSeparator: ".",
        localeCode: "es-MX",
        symbol: "$",
    },
};
export function PriceView({ id, price, locale }) {
    const { decimalSeparator, symbol } = currencies[locale] || {
        decimalSeparator: ",",
        symbol: "$",
    };
    if (!price.includes(decimalSeparator)) {
        return (_jsxs("span", Object.assign({ id: id }, { children: [symbol, " ", price] }), void 0));
    }
    const [entire, cents] = price.split(decimalSeparator);
    return (_jsxs("span", Object.assign({ id: id }, { children: [symbol, " ", entire, _jsx("sup", { children: cents }, void 0)] }), void 0));
}
//# sourceMappingURL=PriceView.js.map